import React from 'react'
import { useDispatch } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, FormFeedback, FormText, Container, Row, Col } from 'reactstrap';
import { Checkbox, FormControlLabel } from '@mui/material';
import { MaterialReactTable } from 'material-react-table';
import { useState, useMemo, useCallback } from "react";
import { potentialClients, propertyRequestForm } from "../actions/admin";
import { Box, IconButton, Tooltip } from '@mui/material';
import { Info, Key } from '@mui/icons-material';
import DetailRequestModal from './detailrequest.modal.component';
import "react-datepicker/dist/react-datepicker.css";

const PotentialClientPropertyViewModal = (props) => {
    const [priceChecked, setPriceChecked] = useState(true);
    const [roomChecked, setRoomChecked] = useState(false);
    const [cityChecked, setCityChecked] = useState(false);
    const [regionChecked, setRegionChecked] = useState(false);
    const [tagsChecked, setTagsChecked] = useState(false);
    const [requestDetails, setRequestDetails] = useState({});
    const [showModalRequest, setShowModalRequest] = useState(false);
    
    const dispatch = useDispatch();
    
    const closeModal = () => {
        props.toggleModalPotentialClients();
        setPriceChecked(true);
        setRoomChecked(false);
        setCityChecked(false);
        setTagsChecked(false);
    }

    const setFilter = (event) => {
        const value = event.target.value;
        switch(value) {
            case "priceFilter":
                setPriceChecked(event.target.checked);
                break;
            case "roomFilter":
                setRoomChecked(event.target.checked);
                break;
            case "cityFilter":
                setCityChecked(event.target.checked);
                break;
            case "regionFilter":
                setRegionChecked(event.target.checked);
                break;
            case "tagsFilter":
                setTagsChecked(event.target.checked);
                break;
            default:
                break;
        }
    }

    const toggleModalDetailRequest = useCallback((requestId) => {
        if (requestId != null && typeof requestId == 'string') {
            dispatch(propertyRequestForm(requestId))
                .then((data) => {
                    setRequestDetails(data.request);
                })
                .catch(() => {
                    console.log("Error");
                });
        } else {
            setRequestDetails({});
        }
        setShowModalRequest(prev => !prev);
    }, [dispatch]);

    const handleChange = (event) => {
        let filterMap = new Map();
        
        if(priceChecked) {
            filterMap.set("priceFilter", "" + props.propertyDetails.price);
        } else {
            filterMap.delete("priceFilter");
        }
        if(roomChecked) {
            filterMap.set("roomFilter", "" + props.propertyDetails.rooms);
        } else {
            filterMap.delete("roomFilter");
        }
        if(cityChecked) {
            if(props.propertyDetails.cityObj && props.propertyDetails.cityObj.id) {
                filterMap.set("cityFilter", props.propertyDetails.cityObj.id);
            }
        } else {
            filterMap.delete("cityFilter");
        }
        if(regionChecked) {
            if(props.propertyDetails.regionObj && props.propertyDetails.regionObj.id) {
                filterMap.set("regionFilter", props.propertyDetails.regionObj.id);
            }
        } else {
            filterMap.delete("regionFilter");
        }
        if(tagsChecked) {
            if(props.propertyDetails.tagIdList && props.propertyDetails.tagIdList.length > 0) {
                filterMap.set("tagsFilter", props.propertyDetails.tagIdList.join(";"));
            }
        } else {
            filterMap.delete("tagsFilter");
        }
        
        if(filterMap.size === 0) {
            props.setPotentialClientList({
                priceFilter: false,
                roomFilter: false,
                cityFilter: false,
                regionFilter: false,
                tagsFilter: false,
                clientList: []
            });
            return;
        }
        dispatch(potentialClients(filterMap))
            .then((data) => {
                props.setPotentialClientList(data); 
            })
            .catch(() => {
                console.log("Error");
            });
    };

    const columns = useMemo(
        () => [
            {
                accessorKey: 'id',
                header: 'Id',
                enableEditing: false

            },
            {
                accessorKey: 'lastname',
                header: 'Cognome'

            },
            {
                accessorKey: 'firstname',
                header: 'Nome'
            },
            {
                accessorKey: 'email',
                header: 'Email'

            }
        ],
        [],
    );

    return (
        <div>
            <Modal id="modalPotentialClients" className="modal-dialog-centered modal-xl" isOpen={props.showModalPotentialClients} toggle={props.toggleModalPotentialClients} >
                <ModalHeader>Possibili Clienti</ModalHeader>
                <ModalBody>
                    <Container>
                        <Row xs="1" sm="1" md="2" lg="12" xl="12">
                            <Col>
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox checked={priceChecked} onChange={setFilter} />}
                                        label="Prezzo"
                                        value="priceFilter" />
                                    <FormControlLabel control={<Checkbox checked={roomChecked} onChange={setFilter} />}
                                        label="Camere"
                                        value="roomFilter" />
                                    <FormControlLabel control={<Checkbox checked={cityChecked} onChange={setFilter} />}
                                        label="Città"
                                        value="cityFilter" />
                                    <FormControlLabel control={<Checkbox checked={regionChecked} onChange={setFilter} />}
                                        label="Regione"
                                        value="regionFilter" />
                                    <FormControlLabel control={<Checkbox checked={tagsChecked} onChange={setFilter} />}
                                        label="Tags"
                                        value="tagsFilter" />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Button className="btn btn-primary custom-btn" onClick={handleChange}>
                                        Filtra
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Container>
                    <MaterialReactTable
                        columns={columns}
                        initialState={{ columnVisibility: { id: false } }}
                        data={props.potentialClientList.clientList}
                        editingMode="modal"
                        enableEditing
                        displayColumnDefOptions={{
                            'mrt-row-actions': {
                                header: '',
                                size: 5
                            },
                        }}
                        renderRowActions={({ row, table }) => (
                            row.original && row.original.requestIdList && (
                                <Box sx={{ display: 'flex', gap: '1rem' }} key={row.original.id}>
                                {
                                    row.original.requestIdList.map((requestId) => (
                                        
                                            <Tooltip arrow placement="right" title={"Richiesta " + requestId}>  
                                                <IconButton onClick={() => toggleModalDetailRequest(requestId)}>
                                                    <Info />
                                                </IconButton>
                                            </Tooltip>
                                        
                                    ))
                                }
                                </Box>
                            )
                        )}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button className="btn btn-primary custom-btn" onClick={closeModal}>
                        Chiudi
                    </Button>
                </ModalFooter>
            </Modal>
            <DetailRequestModal showModalDetail={showModalRequest} toggleModalDetail={toggleModalDetailRequest} requestDetails={requestDetails} />
        </div>
    );
}

export default PotentialClientPropertyViewModal;